// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3vcNC","footer":"ReportModalFilter_footer__2JwxD"};